export default __webpack_public_path__ + "static/media/poggers.73704acf.png";